var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":"","outlined":"","color":"black","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.downloadFile}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-download")]),_vm._v(" "+_vm._s(_vm.dlText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }